import React from 'react';
import Nav from "react-bootstrap/Nav";

export const Jumbotron = (props) => {
  return (
    <div id={props.id} className={`py-3 section-dark ${props.className ?? ""}`} style={props.style}>
      <div className="container py-5">
        {props.children}
      </div>
    </div>
  );
}

export const NavLink = (props) => {
  return (
    <Nav.Link
      href={props.href}
      target={props.target}
      rel={props.rel}
    >
      <span className={`nav-item lead ${props.className}`}>
        {props.children}
      </span>
    </Nav.Link>
  );
}
